import Vue from 'vue'
import Vuex from 'vuex' // 引入vuex
Vue.use(Vuex) //vue注册vuex
 
export default new Vuex.Store({ // 在vuex上挂载store实例配置项
  state: {
    token:sessionStorage.getItem('bx_auth_ticket'),
    isLogin:false
  },
  mutations: {
    setToken(state, value) {
      state.token = value;
    },
  },
  actions: {
  },
  modules: {
  },
  getters:{
    token(state){
            return state.token
        }
    }
})